export const defaultSizes = {
  initSize: {
    w: 400,
    h: 400,
  },
  minSize: {
    w: 100,
    h: 100,
  },
};
